module.exports = __webpack_public_path__ + "img/tech04.92db5e07.png";